module.exports = __webpack_public_path__ + "static/media/cms-contact-icon.1741a020.svg";